import { Box, Table, TableBody, Typography } from "@mui/material";
import { getNiceCoins } from "../../utils/function";

const PriceBox = ({ game, isMobile }) => {
    return (
        <Box mt={3}>
            <Typography align="center" variant={isMobile ? "h6" : "h5"} mb={2}>
                Цены на серверах
            </Typography>
            <Table>
                <TableBody>
                    {
                        game.server.map((server, index) => {
                            const exchane = getNiceCoins(server.rate)
                            return (
                                <Box
                                    key={index}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    gap={1}
                                    p={2}
                                    sx={{
                                        backgroundColor: '#2e2e2e',
                                        borderRadius: '10px',
                                        padding: 2,
                                        width: '100%',
                                        transition: 'background-color 0.3s',
                                        '&:hover': {
                                            backgroundColor: '#3e3e3e'
                                        }
                                    }}
                                >
                                    <Typography variant={isMobile ? "body1" : "h6"}>{server.name}</Typography>
                                    <Typography mb={0} variant={isMobile ? "body2" : "body1"} color="textSecondary">
                                        {exchane.coins + ' ~ ' + exchane.usd + ' руб'}
                                    </Typography>
                                </Box>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </Box>
    );
};

export default PriceBox;